module.exports = __webpack_public_path__ + "static/coaches.a9e296df.png";